import { DIALOG_DATA } from '@angular/cdk/dialog';
import { CommonModule } from '@angular/common';
import { Component, inject, ViewEncapsulation } from '@angular/core';
import { ButtonComponent } from '@app/components/button/button.component';
import { DialogBase } from '@app/components/dialog/dialog-base';
import { CurrencyInfo } from '@app/models/currency-info';
import { GameCurrencyPipe } from '@app/pipes/game-currency.pipe';
import { AngularSvgIconModule } from 'angular-svg-icon';
import { TranslateModule } from '@ngx-translate/core';

export interface TournamentDialogEndResultData {
  tournamentName: string;
  position: number;
  amountWon: number;
  nbPlayerRegistered: number;
  currency: CurrencyInfo
  playerName: string;
}

@Component({
  selector: 'app-tournament-dialog-end-result',
  standalone: true,
  imports: [CommonModule, ButtonComponent, AngularSvgIconModule, GameCurrencyPipe, TranslateModule],
  templateUrl: './tournament-dialog-end-result.component.html',
  styleUrl: './tournament-dialog-end-result.component.scss',
  host: { class: 'dialog app-tournament-dialog-end-result' },
  encapsulation: ViewEncapsulation.None
})
export class TournamentDialogEndResultComponent extends DialogBase {
  dialogData = inject<TournamentDialogEndResultData>(DIALOG_DATA)

  goToLobby() {
    this.dialogRef.close(true);
  }
}
